import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { VerExamenComponent } from '../../../forms/examen/ver-examen/ver-examen.component';



@Component({
  selector: 'app-examen',
  templateUrl: './examen.component.html',
  styleUrls: ['./examen.component.scss']
})
export class ExamenComponent {
  @ViewChild('verCursos') verCursos: VerExamenComponent
  accionesContacto: boolean = true;
  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
  //  console.log(this.verEstadoPropuesta);
  }

  actualizarTabla(): void {
    this.verCursos.actualizarTabla();
  }
}
